import { render, staticRenderFns } from "./miditem.vue?vue&type=template&id=2b20807a&scoped=true&"
import script from "./miditem.vue?vue&type=script&lang=js&"
export * from "./miditem.vue?vue&type=script&lang=js&"
import style0 from "./miditem.vue?vue&type=style&index=0&id=2b20807a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20807a",
  null
  
)

export default component.exports